/* eslint-disable no-unused-vars */
const state = {
  localizations: {
    arr: {
      uk: [],
      ru: [],
      en: []
    },
    obj: {
      uk: null,
      ru: null,
      en: null
    }
  }
}

const actions = {
  setPartnerLocalizationData(context, localization) {
    context.commit('setPartnerLocalizationData', localization)
  },
  clearPartnerLocalizationState(context) {
    context.commit('clearPartnerLocalizationState')
  }
}

const mutations = {
  setPartnerLocalizationData(state, payload) {
    if (Array.isArray(payload.data)) {
      payload.data.forEach(element => {
        element.localizations.forEach(e => {
          var model = {
            id: element.id,
            partnerUrl: element.partnerUrl,
            products: element.products,
            date: new Date(element.date),
            title: '',
            description: [],
            imageId: null
            // localizations: {
            //   id: '',
            //   description: [],
            //   imageId: null,
            //   title: '',
            //   language: ''
            // }
          }
          var loc = {
            id: e.id,
            description: tryToParseJson(e.description),
            imageId: e.imageId,
            title: e.title,
            language: e.language
          }
          model.title = loc.title
          model.description = loc.description
          model.imageId = loc.imageId
          state.localizations.arr[e.language].push(model)
        })
      })
    } else {
      state.localizations[payload.language] = payload
      payload.localizations.forEach(e => {
        var model = {
          id: payload.id,
          partnerUrl: payload.partnerUrl,
          products: payload.products,
          date: getYear(new Date(payload.date)),
          title: e.title,
          description: tryToParseJson(e.description),
          imageId: e.imageId
          // localizations: {
          //   id: '',
          //   description: [],
          //   imageId: null,
          //   title: '',
          //   language: ''
          // }
        }
        state.localizations.obj[`${e.language}`] = model
      })
    }
  },
  clearPartnerLocalizationState() {
    state.localizations.arr.uk = []
    state.localizations.arr.ru = []
    state.localizations.arr.en = []
    state.localizations.obj.uk = null
    state.localizations.obj.ru = null
    state.localizations.obj.en = null
  }
}

const getters = {
  partnerLocalizationuk: state => state.localizations.arr.uk,
  partnerLocalizationru: state => state.localizations.arr.ru,
  partnerLocalizationen: state => state.localizations.arr.en,
  partners: state => state.partnersList,
  partneruk: state => state.localizations.obj.uk,
  partneren: state => state.localizations.obj.en,
  partnerru: state => state.localizations.obj.ru

}

function tryToParseJson(object) {
  var obj = object
  var isJson = false
  while (!isJson) {
    if (typeof obj === 'string') {
      obj = JSON.parse(obj)
    } else {
      isJson = true
    }
  }
  return obj
}
function getYear(date) {
  if (date) {
    var newDate = date.getFullYear()
  }
  return newDate
}
export default {
  state,
  actions,
  mutations,
  getters
}
